import React, { ReactChild, useReducer } from 'react';
import { useLocation } from 'react-router-dom';
import CarrierLogisticsCommonsContext, {
  initialContextValue,
} from './context/CarrierLogisticsCommonsContext';
import CarrierLogisticsCommonsDispatchContext from './context/CarrierLogisticsCommonsDispatchContext';
import authorizationDispatch from './dispatch/authorization/authorisationDispatch';
import localisationDispatch from './dispatch/localisation/localisationDispatch';
import rootReducer from './reducers';

export const CarrierLogisticsCommonsProvider: React.FC<{
  children: ReactChild;
  CLWSCaller: Node;
  isPageAuthorized: Function;
}> = ({ children, CLWSCaller, isPageAuthorized }) => {
  const { pathname } = useLocation();
  const [state, dispatch] = useReducer(rootReducer, initialContextValue);

  return (
    <CarrierLogisticsCommonsContext.Provider value={state}>
      <CarrierLogisticsCommonsDispatchContext.Provider
        value={{ localisationDispatch: localisationDispatch(dispatch) }}
      >
        {children}
        <CLWSCaller
          isPageAuthorized={isPageAuthorized(pathname)}
          authorizationDispatch={authorizationDispatch(dispatch)}
        />
      </CarrierLogisticsCommonsDispatchContext.Provider>
    </CarrierLogisticsCommonsContext.Provider>
  );
};

export default CarrierLogisticsCommonsProvider;
